import React from "react";
import { Helmet } from "react-helmet";
import AppIcons from "../utils/appIcons";
import Strings from "../utils/stringUtil";

function Seo({ title, description, keywords, schema }) {
  const currentUrl = window.location.href;

  return (
    <Helmet>
      <title>{title || Strings.homeMetaTitle}</title>
      <meta
        name="description"
        content={description || Strings.homeMetaDescription}
      />

      {/* Open Graph tags */}
      <meta property="og:title" content={title || Strings.homeMetaTitle} />
      <meta
        property="og:description"
        content={description || Strings.homeMetaDescription}
      />
      <meta property="og:image" content={AppIcons.imgLogo} />
      <meta
        property="og:image:alt"
        content={description || Strings.homeMetaDescription}
      />
      <meta name="keywords" content={keywords || Strings.homeMetaKeyword} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content="Mahila Money" />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}

export default Seo;
